<template>
  <div>
    <div class="pa-0 ma-0" style="background-color: white;">
      <NavBar styleType="finance"></NavBar>
      <div ref="videoContainerEmpty" id="videoContainerEmpty" class="pa-0 ma-0" :style="{ height: videoHeight + 'px' }">
        <div id="videoContent" class="pa-0 ma-0" :style="{ height: videoHeight + 'px' }">
          <div id="bkgrdVideoOverlay" :style="{ height: videoHeight + 'px' }"></div>
        </div>
      </div>
      <div class="body-overall page-top page-bottom fonts" style="color:black!important;">
            <v-row class="textPanel pb-8">
                <div class="container">
                  <v-row justify="start" class="pl-12 pr-12 hidden-xs" >
                    <v-col cols="6" class="pa-0 ma-0">                  
                      <h1 class="font2-heada" style="color:black!important;">PRIVACY POLICY</h1>
                    </v-col>
                    <v-col cols="6" justify="start" class="pa-0 ma-0">  
                      <v-row class="pl-6 pt-5">
                        <span class="mt-0 pb-0 mb-0 fonts-desc" style="color:black!important;">
                          Privacy policies that govern use of 42Monks Capital services for individuals and enterprise users.
                        </span>
                      </v-row>                
                    </v-col>
                  </v-row>
                  <v-row justify="start" class="pl-12 pr-12 hidden-sm-and-up pt-0 mt-0">
                        <h1 class="font2-heada" style="color:black!important;">PRIVACY POLICY</h1>
                  </v-row>
                  <v-row justify="start" class="pl-12 pr-12 pt-4 pb-4 hidden-sm-and-up pt-0 mt-0">
                        <span class="mt-0 pb-0 mb-0 pl-0 fonts-desc" style="color:black!important;">
                          Privacy policies that govern use of 42Monks Capital services for individuals and enterprise users.
                        </span>
                  </v-row>  
                </div>
            </v-row>
            <v-row class="textPanel page-top pb-8">
                <div class="container">
                  <v-divider class="divider ml-9 mr-9 hidden-xs" style="color:black!important;"></v-divider>
                  <v-divider class="dividerxs ml-9 mr-9 hidden-sm-and-up" style="color:black!important;"></v-divider>
                </div>
            </v-row>
      </div>
      <div class="body-overall page-top page-bottom fonts" style="color:black!important;">
            <v-row class="textPanel pb-8">
                <div class="container">
                  <v-row justify="start" class="pl-12 pr-12 hidden-xs">
                    <v-col cols="6" class="pa-0 ma-0">                  
                      <h1 class="font2-heada" style="color:black!important;">Agreement and Acceptance</h1>
                    </v-col>
                    <v-col cols="6" justify="start" class="pa-0 ma-0">  
                      <v-row class="pl-6 pt-5">
                        <span class="mt-0 pb-0 mb-0 fonts-desc" style="color:black!important;">
                          The Privacy Policy, together with our Terms and
Conditions and all other terms, conditions and policies published
on the platform, govern your access to and use of the platform.                        
                        </span>
                      </v-row>                
                    </v-col>
                  </v-row>
                  <v-row justify="start" class="pl-12 pr-12 hidden-sm-and-up pt-0 mt-0">
                        <h1 class="font2-heada" style="color:black!important;">Agreement and Acceptance</h1>
                  </v-row>
                  <v-row justify="start" class="pl-12 pr-12 pt-4 pb-4 hidden-sm-and-up pt-0 mt-0">
                        <span class="mt-0 pb-0 mb-0 pl-0 fonts-desc" style="color:black!important;">
                          The Privacy Policy, together with our Terms and
Conditions and all other terms, conditions and policies published
on the platform, govern your access to and use of the platform.                             
                        </span>
                      </v-row>  
                </div>
            </v-row>
            <v-row class="textPanel page-top pb-8">
                <div class="container">
                  <v-row justify="start" class="pl-12 pr-12 pt-8 mt-0">
                        <span class="mt-0 pb-0 mb-0 pt-6 fonts-xsmall2" style="color:black!important;">
                          This privacy policy (“Privacy Policy” or “Policy”) has been prepared by 42Monks Sp. z o.o. (Registered in Polish National Court Register)
(42Monks, “we”, “us”, “our” or “ours”). Prior to using https://42monks.com and all related subdomains (collectively, the “Website” or "Service" or "Services") of 42monks.com or desktop and/or mobile
applications, you (“user”, “you”, “your” or “yours”) confirm
acceptance of these policies, which supplement and are incorporated into our Terms and
Conditions. This Policy does not intend to override the Terms and Conditions.<br/><br/>
 </span>
                  </v-row>
                </div>
            </v-row>
            <v-row class="textPanel page-top pb-8">
                <div class="container">
                  <v-divider class="divider ml-9 mr-9 hidden-xs" style="color:black!important;"></v-divider>
                  <v-divider class="dividerxs ml-9 mr-9 hidden-sm-and-up" style="color:black!important;"></v-divider>
                </div>
            </v-row>
      </div>
      <div class="body-overall page-top page-bottom fonts" style="color:black!important;">
            <v-row class="textPanel pb-8">
                <div class="container">
                  <v-row justify="start" class="pl-12 pr-12 hidden-xs">
                    <v-col cols="6" class="pa-0 ma-0">                  
                      <h1 class="font2-heada" style="color:black!important;">Personal information</h1>
                    </v-col>
                    <v-col cols="6" justify="start" class="pa-0 ma-0">  
                      <v-row class="pl-6 pt-5">
                        <span class="mt-0 pb-0 mb-0 fonts-desc" style="color:black!important;">
                          This policy governs Personal Information collection, store, use and disclosure.                        
                        </span>
                      </v-row>                
                    </v-col>
                  </v-row>
                  <v-row justify="start" class="pl-12 pr-12 hidden-sm-and-up pt-0 mt-0">
                        <h1 class="font2-heada" style="color:black!important;">Personal information</h1>
                  </v-row>
                  <v-row justify="start" class="pl-12 pr-12 pt-4 pb-4 hidden-sm-and-up pt-0 mt-0">
                        <span class="mt-0 pb-0 mb-0 pl-0 fonts-desc" style="color:black!important;">
                          This policy governs Personal Information collection, store, use and disclosure.                          
                        </span>
                      </v-row>  
                </div>
            </v-row>
            <v-row class="textPanel page-top pb-8">
                <div class="container">
                  <v-row justify="start" class="pl-12 pr-12 pt-8 mt-0">
                        <span class="mt-0 pb-0 mb-0 pt-6 fonts-xsmall2" style="color:black!important;">
                          We process personal data that we receive as part of the (initiation of the) business relationship with you or with a business partner or in another context. We receive the data directly from you, from third parties or obtain it ourselves.  <br/><br/>
                          In particular, we process the following data: <br/><br/>
                          • Master data (e.g. name, address, email address, telephone number) <br/>
                          • Contractual data, i.e. the data we need to process the contractual relationship with you (e.g. type of contract, services, financial data, etc.) <br/>
                          • Communication data <br/><br/>
                          
                          We collect personal information relating to you (“Personal Information”) as follows:

Personal Information You Provide: We collect Personal Information if you create an account to use our Services or communicate with us as follows:<br/><br/>

&#x2022; Account Information: When you create an account with us, we will collect information associated with your account, including your name, contact information, account credentials, payment card information, user data mandatory for KYC and AML when necessary (MiCA compliant), and transaction history, (collectively, “Account Information”).<br/>
&#x2022; User Content: When you use our Services, we collect Personal Information that is included in the input, file uploads, or feedback that you provide to our Services (“Content”). <br/>
&#x2022; Communication Information: If you communicate with us, we collect your name, contact information, and the contents of any messages you send (“Communication Information”).<br/>
&#x2022; Other Information You Provide: We collect other information that you may provide to us, such as when you participate in our events or surveys or provide us with information to establish your identity (collectively, “Other Information You Provide”).<br/><br/>
Personal Information We Receive Automatically From Your Use of the Services: When you visit, use, or interact with the Services, we receive the following information about your visit, use, or interactions (“Technical Information”):<br/><br/>

&#x2022; Log Data: Information that your browser or device automatically sends when you use our Services. Log data includes your Internet Protocol address, browser type and settings, the date and time of your request, and how you interact with our Services.<br/>
&#x2022; Usage Data: We may automatically collect information about your use of the Services, such as the types of content that you view or engage with, the features you use and the actions you take, as well as your time zone, country, the dates and times of access, user agent and version, type of computer or mobile device, and your computer connection.<br/>
&#x2022; Device Information: Includes name of the device, operating system, device identifiers, and browser you are using. Information collected may depend on the type of device you use and its settings.<br/>
&#x2022; Shared Information: We may also receive personal data from third parties who you authorize sharing your
personal data with us. Where such personal data so received is subject to processing only
upon your consent, we shall seek your clear, informed and unambiguous consent for
processing such personal data. We may collect, process and store your wallet information and cookies / browser data
associated with any third-party service provider account that you use to access the Platform
or connect with or use the Platform. When you access our Platform with your third-party
account information, we may collect, store, and use, in accordance with this Policy, the
information that you make available to us through the third party. This could include, without
limitation, any information that you have made public through your third-party account,
information that the third-party service provider shares with us, or information that is
disclosed during the sign-in process.<br/>

&#x2022; Cookies: We use cookies to operate and administer our Services, and improve your experience. A “cookie” is a piece of information sent to your browser by a website you visit. You can set your browser to accept all cookies, to reject all cookies, or to notify you whenever a cookie is offered so that you can decide each time whether to accept it. 
However, refusing a cookie may in some cases preclude you from using, or negatively affect the display or function of, a website or certain areas or features of a website. <br/>
&#x2022; Analytics: We may use a variety of online analytics products that use cookies to help us analyze how users use our Services and enhance your experience when you use the Services.
                        </span>
                  </v-row>
                  <v-row justify="start" class="pl-12 pr-12 pt-8 mt-0">
                        <span class="mt-0 pb-0 mb-0 pt-6 fonts-xsmall2" style="color:black!important;">
                          We may use Personal information for the following purposes:<br/><br/>

                          &#x2022; To provide, administer, maintain and/or analyze the Services;<br/>
                          &#x2022; To improve our Services and conduct research;<br/>
                          &#x2022; To communicate with you; including to send you information about our Services and events;<br/>
                          &#x2022; To develop new programs and services;<br/>
                          &#x2022; To prevent fraud, criminal activity, or misuses of our Services, and to protect the security of our IT systems, architecture, and networks;<br/>
                          &#x2022; To carry out business transfers;<br/>
                          &#x2022; To comply with legal obligations and legal process and to protect our rights, privacy, safety, or property, and/or that of our affiliates, you, or other third parties.<br/><br/><br/>
<b>Aggregated or De-Identified information.</b><br/>
We may aggregate or de-identify Personal Information so that it may no longer be used to identify you and use such information to analyze the effectiveness of our Services, to improve and add features to our Services, to conduct research and for other similar purposes. <br/>
In addition, from time to time, we may analyze the general behavior and characteristics of users of our Services and share aggregated information like general user statistics with third parties,
 publish such aggregated information or make such aggregated information generally available. <br/>
 We may collect aggregated information through the Services, through cookies, and through other means described in this Privacy Policy. 
 <br/>We will maintain and use de-identified information in anonymous or de-identified form and we will not attempt to reidentify the information, unless required by law.
 <br/><br/><br/>
<b>Consequences of refusal, failure, inability to provide necessary information.</b><br/>
In the event that you fail, neglect and/ or refuse to, or are unable to provide us with any
personal data which we necessarily need to provide you with services or the Platform, or
which we need to collect by law, we may not be able to provide you services through the
Platform. In this case, we have the right to discontinue the provision of the Platform to you.
In such a situation, we will reserve the right to do so without notification.
                        </span>
                  </v-row>

                  <v-row justify="start" class="pl-12 pr-12 pt-8 mt-0">
                        <span class="mt-0 pb-0 mb-0 pt-6 fonts-xsmall2" style="color:black!important;">
                          <b>Purposes and legitimate interests.</b><br/>
                                42Monks takes its data protection and privacy responsibilities serious. 
                                We do not rely on your consent as a lawful basis for processing your personal data other than in relation to sending direct marketing communications to you via email. 
                                You have the right to withdraw your consent to marketing at any time by contacting us on the details given at the beginning of this notice. 
                                We may process your personal data without your knowledge or consent, in compliance with the above rules, if we have a legitimate interest for doing so because we are required 
                                by law or contract to do so or if we reasonably believe that it is necessary to protect our contractual rights or to meet our contractual obligations and/or to comply with judicial 
                                or regulatory proceedings, a court order or other legal process. 
                                where anti-money-laundering (AML) regulations, trade sanctions regulations or tax reporting obligations (like OECD Common Reporting Standards) arise and we must use your personal data to 
                                discharge our contractual and regulatory obligations. <br/><br/>
                                We will only use your personal data for the purposes for which we collected it as identified above, unless we reasonably consider that we need to use it for another reason which is 
                                compatible with the original purpose for which you provided it to us. <br/><br/>
                                You are required to provide personal data for statutory, regulatory, tax compliance and contractual purposes. 
                                If you do not provide us with certain personal data when requested, we will not be able to perform all or part of the contract we have entered into with you, 
                                or we may be prevented from complying with our legal obligations. This may result in terminating our relationship with you. 
                        </span>
                  </v-row>

                  <v-row justify="start" class="pl-12 pr-12 pt-8 mt-0">
                        <span class="mt-0 pb-0 mb-0 pt-6 fonts-xsmall2" style="color:black!important;">
                          <b>Disclosure of personal information.</b><br/>
In certain circumstances we may provide your Personal Information to third parties without further notice to you, unless required by the law:<br/><br/>

&#x2022; Vendors and Service Providers: To assist us in meeting business operations needs and to perform certain services and functions, we may provide Personal Information to vendors and service providers, including providers of hosting services, customer service vendors, cloud services, email communication software, web analytics services, and other information technology providers, among others. 
Pursuant to our instructions, these parties will access, process, or store Personal Information only in the course of performing their duties to us.<br/>
&#x2022; Business Transfers: If we are involved in strategic transactions, reorganization, bankruptcy, receivership, or transition of service to another provider (collectively, a “Transaction”), your Personal Information and other information may be disclosed in the diligence process with counterparties and others assisting with the Transaction and transferred to a successor or affiliate as part of that Transaction along with other assets.<br/>
&#x2022; Legal Requirements: We may share your Personal Information, including information about your interaction with our Services, with government authorities, industry peers, or other third parties (i) if required to do so by law or in the good faith belief that such action is necessary to comply with a legal obligation, (ii) to protect and defend our rights or property, (iii) if we determine, in our sole discretion, that there is a violation of our terms, policies, or the law; (iv) to detect or prevent fraud or other illegal activity; (v) to protect the safety, security, and integrity of our products, employees, or users, or the public, or (vi) to protect against legal liability.<br/>
&#x2022; Affiliates: We may disclose Personal Information to our affiliates, meaning an entity that controls, is controlled by, or is under common control with 42Monks. Our affiliates may use the Personal Information we share in a manner consistent with this Privacy Policy.<br/>
&#x2022; Business Account Administrators: When you join a 42Monks Enterprise or business account, the administrators of that account may access and control your 42Monks account. In addition, if you create an account using an email address belonging to your employer or another organization, we may share the fact that you have an 42Monks account and certain account information, such as your email address, with your employer or organization to, for example, enable you to be added to their business account.<br/>
&#x2022; Other Users and Third Parties You Share Information With: Certain features allow you to display or share information with other users or third parties. For example, you may share 42Monks or send information to third-party applications via custom actions for 42Monks. Be sure you trust any user or third party with whom you share information.<br/><br/>
42Monks does not sell personal data obtained about you to third parties that are not associated with us for the purpose of marketing their products or services to you. 
                        </span>
                  </v-row>
                </div>
            </v-row>




            <v-row class="textPanel page-top pb-8">
                <div class="container">
                  <v-divider class="divider ml-9 mr-9 hidden-xs" style="color:black!important;"></v-divider>
                  <v-divider class="dividerxs ml-9 mr-9 hidden-sm-and-up" style="color:black!important;"></v-divider>
                </div>
            </v-row>
            <v-row class="textPanel pb-8">
                <div class="container">
                  <v-row justify="start" class="pl-12 pr-12 hidden-xs">
                    <v-col cols="6" class="pa-0 ma-0">                  
                      <h1 class="font2-heada" style="color:black!important;">Your rights</h1>
                    </v-col>
                    <v-col cols="6" justify="start" class="pa-0 ma-0">  
                      <v-row class="pl-6 pt-5">
                        <span class="mt-0 pb-0 mb-0 fonts-desc" style="color:black!important;">
                          Depending on location, individuals may have certain statutory rights in relation to their Personal Information.              
                        </span>
                      </v-row>          
                    </v-col>
                  </v-row>
                  <v-row justify="start" class="pl-12 pr-12 hidden-sm-and-up pt-0 mt-0">
                        <h1 class="font2-heada" style="color:black!important;">Your rights</h1>
                  </v-row>
                      <v-row justify="start" class="pl-12 pr-12 pt-4 pb-4 hidden-sm-and-up pt-0 mt-0">
                        <span class="mt-0 pb-0 mb-0 pl-0 fonts-desc" style="color:black!important;">
                          Depending on location, individuals may have certain statutory rights in relation to their Personal Information.                         
                        </span>
                      </v-row>   
                </div>
            </v-row>
            <v-row class="textPanel page-top pb-8">
                <div class="container">
                  <v-row justify="start" class="pl-12 pr-12 pt-8 mt-0">
                        <span class="mt-0 pb-0 mb-0 pt-6 fonts-xsmall2" style="color:black!important;">
                          For example, you may have the right to:<br/><br/>

                          &#x2022; Access your Personal Information and information relating to how it is processed.<br/>
                          &#x2022; Delete your Personal Information from our records.<br/>
                          &#x2022; Rectify or update your Personal Information.<br/>
                          &#x2022; Transfer your Personal Information to a third party (right to data portability).<br/>
                          &#x2022; Restrict how we process your Personal Information.<br/>
                          &#x2022; Withdraw your consent—where we rely on consent as the legal basis for processing at any time. <br/>
                          &#x2022; Object to how we process your Personal Information.<br/>
                          &#x2022; Lodge a complaint with your local data protection authority.<br/>
                        </span>
                  </v-row>
                </div>
              </v-row>




            <v-row class="textPanel page-top pb-8">
                <div class="container">
                  <v-divider class="divider ml-9 mr-9 hidden-xs" style="color:black!important;"></v-divider>
                  <v-divider class="dividerxs ml-9 mr-9 hidden-sm-and-up" style="color:black!important;"></v-divider>
                </div>
            </v-row>
            <v-row class="textPanel pb-8">
                <div class="container">
                  <v-row justify="start" class="pl-12 pr-12 hidden-xs">
                    <v-col cols="6" class="pa-0 ma-0">                  
                      <h1 class="font2-heada" style="color:black!important;">Security and Retention</h1>
                    </v-col>
                    <v-col cols="6" justify="start" class="pa-0 ma-0">  
                      <v-row class="pl-6 pt-5">
                        <span class="mt-0 pb-0 mb-0 fonts-desc" style="color:black!important;">
                          We implement commercially reasonable technical, administrative, and organizational measures to protect Personal Information both online and offline from loss, misuse, and unauthorized access, disclosure, alteration, or destruction.             
                        </span>
                      </v-row>          
                    </v-col>
                  </v-row>
                  <v-row justify="start" class="pl-12 pr-12 hidden-sm-and-up pt-0 mt-0">
                        <h1 class="font2-heada" style="color:black!important;">Security and Retention</h1>
                  </v-row>
                      <v-row justify="start" class="pl-12 pr-12 pt-4 pb-4 hidden-sm-and-up pt-0 mt-0">
                        <span class="mt-0 pb-0 mb-0 pl-0 fonts-desc" style="color:black!important;">
                          We implement commercially reasonable technical, administrative, and organizational measures to protect Personal Information both online and offline from loss, misuse, and unauthorized access, disclosure, alteration, or destruction.                       
                        </span>
                      </v-row>   
                </div>
            </v-row>
            <v-row class="textPanel page-top pb-8">
                <div class="container">
                  <v-row justify="start" class="pl-12 pr-12 pt-8 mt-0">
                        <span class="mt-0 pb-0 mb-0 pt-6 fonts-xsmall2" style="color:black!important;">
                          No Internet or email transmission is ever fully secure or error free. 
                          Without prejudice to our efforts on the protection of your data, nothing contained
in this Policy constitutes a warranty of security of the facilities, and you agree to
transmit data at your own risk. Please note, that we do not guarantee that your data may not be accessed,
disclosed, altered, or destroyed by breach of any of our physical, technical, or
managerial safeguards.
                          In particular, email sent to or from us may not be secure. Since we cannot guarantee against any loss, misuse, unauthorized acquisition, or
alteration of your data, please take the necessary steps to protect your own
personal data, including the adoption of sufficient safety measures such as your
choosing of an appropriate password of sufficient length and complexity and to
not reveal this password to any third parties. Therefore, you should take special care in deciding what information you send to us via the Service or email. 
                          In addition, we are not responsible for circumvention of any privacy settings or security measures contained on the Service, or third-party websites.<br/><br/>

We’ll retain your Personal Information for only as long as we need in order to provide our Service to you, or for other legitimate business purposes such as resolving disputes, safety and security reasons, or complying with our legal obligations. 
How long we retain Personal Information will depend on a number of factors, such as the amount, nature, and sensitivity of the information, the potential risk of harm from unauthorized use or disclosure, our purpose for processing the information, and any legal requirements.<br/><br/>
If you choose to restrict the collection or use of your confidential and personal data, please
stop using the Platform immediately.
                        </span>
                  </v-row>
                </div>
              </v-row>




            <v-row class="textPanel page-top pb-8">
                <div class="container">
                  <v-divider class="divider ml-9 mr-9 hidden-xs" style="color:black!important;"></v-divider>
                  <v-divider class="dividerxs ml-9 mr-9 hidden-sm-and-up" style="color:black!important;"></v-divider>
                </div>
            </v-row>
            <v-row class="textPanel pb-8">
                <div class="container">
                  <v-row justify="start" class="pl-12 pr-12 hidden-xs">
                    <v-col cols="6" class="pa-0 ma-0">                  
                      <h1 class="font2-heada" style="color:black!important;">International users</h1>
                    </v-col>
                    <v-col cols="6" justify="start" class="pa-0 ma-0">  
                      <v-row class="pl-6 pt-5">
                        <span class="mt-0 pb-0 mb-0 fonts-desc" style="color:black!important;">
                          By using our Service, you understand and acknowledge that your Personal Information will be 
                          processed and stored in our facilities and servers in the Europe and may be disclosed to our service providers and affiliates in other jurisdictions.       
                        </span>
                      </v-row>          
                    </v-col>
                  </v-row>
                  <v-row justify="start" class="pl-12 pr-12 hidden-sm-and-up pt-0 mt-0">
                        <h1 class="font2-heada" style="color:black!important;">International users</h1>
                  </v-row>
                      <v-row justify="start" class="pl-12 pr-12 pt-4 pb-4 hidden-sm-and-up pt-0 mt-0">
                        <span class="mt-0 pb-0 mb-0 pl-0 fonts-desc" style="color:black!important;">
                          By using our Service, you understand and acknowledge that your Personal Information will be 
                          processed and stored in our facilities and servers in the Europe and may be disclosed to our service providers and affiliates in other jurisdictions.                       
                        </span>
                      </v-row>   
                </div>
            </v-row>
            <v-row class="textPanel page-top pb-8">
                <div class="container">
                  <v-row justify="start" class="pl-12 pr-12 pt-8 mt-0">
                        <span class="mt-0 pb-0 mb-0 pt-6 fonts-xsmall2" style="color:black!important;">
<b>Legal Basis for Processing.</b><br/> Our legal bases for processing your Personal Information include:<br/><br/>

Performance of a contract with you when we provide and maintain our Services. When we process Account Information, Content, and Technical Information solely to provide our Services to you, this information is necessary to be able to provide our Services. If you do not provide this information, we may not be able to provide our Services to you. <br/>
Our legitimate interests in protecting our Services from abuse, fraud, or security risks, or in developing, improving, or promoting our Services, including when we train our models. This may include the processing of Account Information, Content, Social Information, and Technical Information. <br/>
Your consent when we ask for your consent to process your Personal Information for a specific purpose that we communicate to you. You have the right to withdraw your consent at any time.<br/>
Compliance with our legal obligations when we use your Personal Information to comply with applicable law or when we protect our or our affiliates’, users’, or third parties’ rights, safety, and property.<br/><br/>
<b>Data Transfers.</b> <br/>Where required, we will use appropriate safeguards for transferring Personal Information outside of certain countries. We will only transfer Personal Information pursuant to a legally valid transfer mechanism.
                        </span>
                  </v-row>
                </div>
              </v-row>



            
            <v-row class="textPanel page-top pb-8">
                <div class="container">
                  <v-divider class="divider ml-9 mr-9 hidden-xs" style="color:black!important;"></v-divider>
                  <v-divider class="dividerxs ml-9 mr-9 hidden-sm-and-up" style="color:black!important;"></v-divider>
                </div>
            </v-row>
            <v-row class="textPanel pb-16">
                <div class="container">
                  <v-row justify="start" class="pl-12 pr-12 hidden-xs">
                    <v-col cols="6" class="pa-0 ma-0">                  
                      <h1 class="font2-heada" style="color:black!important;">Changes to the privacy policy</h1>
                    </v-col>
                    <v-col cols="6" justify="start" class="pa-0 ma-0">  
                      <v-row class="pl-6 pt-5">
                        <span class="mt-0 pb-0 mb-0 fonts-desc" style="color:black!important;">
                          We may update this Privacy Policy from time to time. When we do, we will post an updated version on this page, unless another type of notice is required by applicable law.            
                        </span>
                      </v-row>          
                    </v-col>
                  </v-row>
                  <v-row justify="start" class="pl-12 pr-12 hidden-sm-and-up pt-0 mt-0">
                        <h1 class="font2-heada" style="color:black!important;">Changes to the privacy policy</h1>
                  </v-row>
                      <v-row justify="start" class="pl-12 pr-12 pt-4 pb-4 hidden-sm-and-up pt-0 mt-0">
                        <span class="mt-0 pb-0 mb-0 pl-0 fonts-desc" style="color:black!important;">
                          We may update this Privacy Policy from time to time. When we do, we will post an updated version on this page, unless another type of notice is required by applicable law.                       
                        </span>
                      </v-row>   
                </div>
            </v-row>
      </div>
          <div class="body-overall fonts">
            <v-row class="textPanel pb-0">
              <v-divider class="divider ml-9 mr-9 hidden-xs mt-14" style="color: black!important;"></v-divider>
              <v-divider class="dividerxs ml-9 mr-9 hidden-sm-and-up mt-14" style="color: black!important;"></v-divider>
            </v-row>
          </div>
      <div class="body-overall fonts">
          <Footer typed="finance"></Footer>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from './NavBar'
import Footer from './Footer'

export default {
  name: 'Privacy',
  props: ['drawerham'],

  components: {
    NavBar,
    Footer
  },
  data: () => ({
    videoHeight: 1000 // Initial height of the video
  }),
  mounted() {  
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  destroyed() {
  },
  computed: {

  },  
  created() {

  }, 
  methods: {
    handleScroll() {
      if (!this.drawerham){
        // Get the current scroll position
        const scrollPosition = Math.round(window.scrollY || window.pageYOffset);
        // Calculate the new height for the video
        const newVideoHeight = Math.round(Math.max(500, 1000 - scrollPosition));
        // Update the video height
        this.videoHeight = newVideoHeight;
      }
    },
    handleClickVideo(link){      
        if (this.$route.name !== link ) {
          this.$router.push({ name: link });
        }     
    },
  },
}
</script>

<style lang="scss" scoped>

@use './css/styles.scss';
@use './css/styles_finance.scss';

:deep(.v-btn:hover)>.v-btn__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

:deep(.v-btn[aria-haspopup=menu][aria-expanded=true])>.v-btn__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

:deep(.v-btn[aria-haspopup=menu][aria-expanded=true]:hover)>.v-btn__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

:deep(.v-list-item:hover)>.v-list-item__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

:deep(.v-list-item__append){
  display: inline-block;
}

#videoContainerEmpty {
  position: relative;
  box-sizing: border-box;
  max-height: 100px;
  transition: height 0.10s linear;
}

#videoContent {
  position: sticky;
  top: 0;
  max-height: 100px;
  transition: height 0.10s linear;
}

#bkgrdVideoOverlay {
  position: absolute;
  top:0;
  left:0;
  width: 100%;
  max-height: 100px;
  object-fit: cover; 
  background-color: #00000000; 
  z-index: 5;
  transition: height 0.10s linear;
}

.body-overall {
  background-color: white !important;
  margin: 0; /* Remove default margin */
  padding: 0; /* Remove default padding */
  z-index: 3;
}


.nomenu-btn-page {
  color: white;
  font-family: "Darker Grotesque", sans-serif;
  font-weight: 500;
  font-size: 20px;
  transition: none !important;
  box-shadow: none !important;
  background-color: transparent !important;
  margin-left: 10px;
  padding-left: 2px;
  margin-right: 10px;
  padding-right: 2px;
}

.nomenu-btn-page.active,
.nomenu-btn-page:hover {
  color: white;
  background-color: transparent !important;
  transition: none;
}

.nomenu-btn-page::before {
  content: "";
  position: absolute;
  left: 4px;
  top: 30px;
  width: 92%; /* Spread the line over the text and icon */
  height: 1px; /* Line thickness */
  background-color: white; /* Color of the underline */
  opacity: 1; /* Initially hide the underline */
}

.nomenu-btn-page.active::before,
.nomenu-btn-page:hover::before {
  opacity: 0.3; /* Show the underline when hovering */
}

.nomenu-btn-link {
  color: white;
  font-family: "Darker Grotesque", sans-serif;
  font-weight: 500;
  font-size: 20px;
  transition: none !important;
  background-color: transparent !important;
  margin-left: 10px;
  padding-left: 2px;
  margin-right: 10px;
  padding-right: 2px;
}

.nomenu-btn-link.active,
.nomenu-btn-link:hover {
  color: white;
  background-color: transparent !important;
  transition: none;
}

.nomenu-btn-link::before {
  content: "";
  position: absolute;
  left: 0px;
  top: 30px;
  width: 100%; /* Spread the line over the text and icon */
  height: 1px; /* Line thickness */
  background-color: black; /* Color of the underline */
  opacity: 0; /* Initially hide the underline */
}

.nomenu-btn-link.active::before,
.nomenu-btn-link:hover::before {
  opacity: 1; /* Show the underline when hovering */
}


</style>

